/*
 * @Author: ROYIANS
 * @Date: 2022/11/18 17:07
 * @Description:
 * @sign:
 * ╦═╗╔═╗╦ ╦╦╔═╗╔╗╔╔═╗
 * ╠╦╝║ ║╚╦╝║╠═╣║║║╚═╗
 * ╩╚═╚═╝ ╩ ╩╩ ╩╝╚╝╚═╝
 */
export const CONFIG = {
  COMMON_SCALE: 5,
  PAGE_SIZE: {
    A1: {
      name: 'A1',
      w: 594,
      h: 841
    },
    A2: {
      name: 'A2',
      w: 420,
      h: 594
    },
    A3: {
      name: 'A3',
      w: 297,
      h: 420
    },
    A4: {
      name: 'A4',
      w: 210,
      h: 297
    },
    A5: {
      name: 'A5',
      w: 148,
      h: 210
    },
    A6: {
      name: 'A6',
      w: 105,
      h: 148
    },
    A7: {
      name: 'A7',
      w: 74,
      h: 105
    },
    B1: {
      name: 'B1',
      w: 707,
      h: 1000
    },
    B2: {
      name: 'B2',
      w: 500,
      h: 707
    },
    B3: {
      name: 'B3',
      w: 353,
      h: 500
    },
    B4: {
      name: 'B4',
      w: 250,
      h: 353
    },
    B5: {
      name: 'B5',
      w: 176,
      h: 250
    },
    B6: {
      name: 'B6',
      w: 125,
      h: 176
    },
    B7: {
      name: 'B7',
      w: 88,
      h: 125
    },
    C1: {
      name: 'C1',
      w: 648,
      h: 917
    },
    C2: {
      name: 'C2',
      w: 458,
      h: 648
    },
    C3: {
      name: 'C3',
      w: 324,
      h: 458
    },
    C4: {
      name: 'C4',
      w: 229,
      h: 324
    },
    C5: {
      name: 'C5',
      w: 162,
      h: 229
    },
    C6: {
      name: 'C6',
      w: 114,
      h: 162
    },
    C7: {
      name: 'C7',
      w: 81,
      h: 114
    }
  }
}
